const staticImage = {
  methods: {
    $staticImage(imageName) {
      return `${this.$store.state.baseAssetsUrl}/staticImages/${imageName}`.replace(/\/{2,}/g, '/');
    }
  }
};

export default staticImage;
